// TODO make argument types consistent
import { BookingRequestParams } from 'types/models/utilities';
import { bestpark } from './base-api';
import moment from 'moment';
import { getApiKeyHeader } from 'helpers/user-helpers';
import { API_KEYS } from 'constants/auth';

const DATE_FORMAT = 'YYYY-MM-DD';

const getParks = async (key: string, locale: string): Promise<Park[]> => {
  const result = await bestpark.get(`/parks/?lang=${locale}`);
  return result.data;
};

const getPark = async (
  key: string,
  id: string | undefined,
  locale: string,
  data: string = '',
): Promise<Park> => {
  const result = await bestpark.get(
    `/parks/${id}/?lang=${locale}${data ? '&data=' + data : ''}`,
  );
  return result.data;
};

const getAvailableSlots = async (
  key: string,
  id: number | undefined,
  startDate: Date,
  endDate: Date,
): Promise<Reservation> => {
  const start = moment(startDate).format(DATE_FORMAT);
  const end = moment(endDate).format(DATE_FORMAT);
  const result = await bestpark.get(
    `/parks/${id}/reservations/available-slots-count?startDate=${start}&endDate=${end}`,
  );
  return result.data;
};

const getAvailableParkingSlots = async (
  key: string,
  id: number | undefined,
  startDate: Date,
  endDate: Date,
): Promise<Reservation> => {
  const start = moment(startDate).format(DATE_FORMAT);
  const end = moment(endDate).format(DATE_FORMAT);
  const result = await bestpark.get(
    `/parks/${id}/reservations/available-parking-slots-count?startDate=${start}&endDate=${end}`,
  );
  return result.data;
};

const getSlotAvailable = async (
  parkId: number,
  startDate: Date,
  endDate: Date,
  customerId: number,
): Promise<number[]> => {
  const start = moment(startDate).format(DATE_FORMAT);
  const end = moment(endDate).format(DATE_FORMAT);
  const result = await bestpark.get(
    `/parks/${parkId}/reservations/available-slots?startDate=${start}&endDate=${end}&customerId=${customerId}`,
  );
  return result.data;
};

const getParkingSlotAvailable = async (
  parkId: number,
  startDate: Date,
  endDate: Date,
  customerId: number,
): Promise<number[]> => {
  const start = moment(startDate).format(DATE_FORMAT);
  const end = moment(endDate).format(DATE_FORMAT);
  const result = await bestpark.get(
    `/parks/${parkId}/reservations/available-parking-slots?startDate=${start}&endDate=${end}&customerId=${customerId}`,
  );
  return result.data;
};

const getAvailableAncillaries = async (
  key: string,
  id: number | undefined,
  start: Date,
  end: Date,
): Promise<AncillarySlots> => {
  const result = await bestpark.get(
    `/parks/${id}/ancillaries/available-slots?startDate=${start}&endDate=${end}`,
  );

  return result.data;
};

const getParkAncillaries = async (
  key: string,
  id: number | undefined,
  locale: string,
): Promise<ParkAncillary[]> => {
  const result = await bestpark.get(`/parks/${id}/ancillaries?lang=${locale}`);
  return result.data;
};

const getPrices = async (
  key: string,
  id: string | undefined,
  startDate: Date,
  endDate: Date,
): Promise<any> => {
  const start = moment(startDate).format(DATE_FORMAT);
  const end = moment(endDate).format(DATE_FORMAT);
  const result = await bestpark.get(
    `/parks/${id}/prices?startDate=${start}&endDate=${end}`,
  );
  return result.data;
};

const getParkFaqs = async (
  key: string,
  id: number,
  locale: string,
): Promise<Faq[]> => {
  const result = await bestpark.get(`/parks/${id}/faqs?lang=${locale}`);
  return result.data;
};

const sendBookingRequest = async (
  data: BookingRequestParams,
): Promise<void> => {
  const { campId, ...body } = data;
  const result = await bestpark.post(
    `/camps/${campId}/booking-request`,
    body,
    getApiKeyHeader(API_KEYS.CAMPS),
  );
  return result.data;
};

export const parksApi = {
  getParks,
  getPark,
  getAvailableSlots,
  getAvailableParkingSlots,
  getSlotAvailable,
  getParkingSlotAvailable,
  getAvailableAncillaries,
  getParkAncillaries,
  getPrices,
  getParkFaqs,
  sendBookingRequest,
};
